export default function PineMark({ size = 28, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 2000 1980.87"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="PINE Systems"
      className={className}
      style={{ display: "block" }}
    >
      <polygon
        fill="currentColor"
        points="0 714.29 987.3 714.29 1126.98 1044.44 730.16 1980.87 152.38 1980.87 488.89 1215.87 228.57 1215.87 0 714.29"
      />
      <polygon
        fill="currentColor"
        points="247.62 501.59 1451.83 501.59 1514.29 638.1 1269.84 1212.7 1749.21 1212.7 2000 644.44 1720.63 0 520.63 0 247.62 501.59"
      />
    </svg>
  );
}
